module.exports = "/v2/pages/dashboard/dist/53e3a92032ea12988c954ee282847fd1.svg";